export default {
  organizations: {
    data: [],
  },
};
